import React from 'react'
import './WebsiteInviteModulePreview.scss'
import 'react-add-to-calendar/dist/react-add-to-calendar.css'
import {GiChurch, GiFamilyHouse} from 'react-icons/gi';
import {ImLocation} from 'react-icons/im';
import {IoMdRestaurant} from 'react-icons/io'
import {Button, Icon} from 'rsuite'
import {
    getUrlFromImage,
    LoadingScreen,
    PlayAudio,
    PlayVideo
} from '../components/Helper';
import moment from "moment-timezone";
import {
    getAnimation2PredefinedSets,
    getDefaultTemplateValues, getIntroAnimationConfigValues,
    getTemplateConfigValues,
    openMaps,
    openWaze
} from "../../components/InviteTemplatesFunctions";
import {SiGooglemaps, SiWaze} from "react-icons/si";
import CustomInput from "../../components/custom/CustomInput";
import {toast} from "react-toastify";
import InviteTemplateRenderLazy from "../../components/inviteTemplates/InviteTemplateRenderLazy";
import IntroAnimationRenderComp
    from "../../components/inviteTemplates/components/IntroAnimationRenderComp/IntroAnimationRenderComp";
import Modal from "react-responsive-modal"
import IntroScreenTemplateRenderLazy
    from "../../components/inviteTemplates/IntroScreen/IntroScreenTemplateRenderLazy";
import {isCorporateWeddingEvent, translateInviteTexts} from "../../functions";
import gsap from "gsap";
import {useGSAP} from "@gsap/react";
import "./WebsiteInviteModuleDemo.scss"
import {corporateWeddingEvents} from "../../const";
import {CustomQuestions} from "../../components/Helper";
import {getTemplateSettingsById} from "../../components/inviteTemplates/inviteTemplates";

gsap.registerPlugin(useGSAP);
class WebsiteInviteModuleDemo extends React.Component {
    state = {
        eventType: "",
        inviteType: "",
        inviteContents: [],
        current_event: [],
        locations: [],
        loading: true,
        topRef: React.createRef(),
        formRef: React.createRef(),
        answer: "",
        nume: "",
        prenume: "",
        insotit: false,
        nume_insotitor: "",
        cuCopii: false,
        nr_copii: 1,
        kidsNumberOptions: ["1", "2", "3", "4", "5"],
        customQuestions: [],
        shouldUseCustomQuestions: true,
        answers: [],
        isUsingAudio: false,
        serverAudioUrl: null,
        showIntroAnimation: false,
        showAnimationAskModal: false,
        showIntroScreen: false,
        animationState: null
    }
    queryParams = new URLSearchParams(this.props.location.search);
    eventType = this.queryParams.get('eventType')
    templateId = this.queryParams.get('templateId')

    getLocatii = () => {
        if (this.eventType === 'Nunta' || this.eventType === 'NuntaBotez') {
            return [
                {
                    "day": moment().add('1', 'year').toISOString(),
                    "name": "Locatie petrecere",
                    "pinx": 44.451627,
                    "piny": 26.085265,
                    "time": moment().add('1', 'year').add('1', 'hour').toISOString(),
                    "address": "Creative Ality, Romania"
                }
            ]
        } else {
            return [
                {
                    "day": moment().add('1', 'year').toISOString(),
                    "name": "Ne întâlmin cu toții la",
                    "pinx": 44.451627,
                    "piny": 26.085265,
                    "time": moment().add('1', 'year').add('1', 'hour').toISOString(),
                    "address": "Creative Ality, Romania",
                    "label": "Teatrul național"
                },
                {
                    "day": moment().add('1', 'year').toISOString(),
                    "name": "Locatie petrecere",
                    "pinx": 44.451627,
                    "piny": 26.085265,
                    "time": moment().add('1', 'year').add('1', 'hour').toISOString(),
                    "address": "Creative Ality, Romania"
                }
            ]
        }


    }

    getValueObjectValue(valueObject, weddingData, templateDetails) {

        if (valueObject.type === 'plain') {
            return valueObject.value
        }

        if (valueObject.type === 'variable') {
            if (valueObject.main_object === 'templateDetails') {
                if (valueObject.secondary_object) {
                    return templateDetails[valueObject.secondary_object][valueObject.parameter]
                } else {
                    return templateDetails[valueObject.parameter]
                }
            }
        }
        if (valueObject.type === 'event_title_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section1.groomName + '\n'
                    + (templateDetails.section1.separator && templateDetails.section1.separator === 1 ? translateInviteTexts('și', weddingData.invite.language) : '&') + '\n'
                    + templateDetails.section1.brideName
            }
            if (weddingData.eventType === 'Botez' || weddingData.eventType === 'Mot' || weddingData.eventType === 'Turta') {
                return templateDetails.section1.groomName
            }
            if (weddingData.eventType === 'Petrecere') {
                return templateDetails.section1.groomName
            }
            if (isCorporateWeddingEvent(weddingData)) {
                return templateDetails.section1.groomName
            }
        }

        if (valueObject.type === 'parents_text_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section2.text1 + '\n'
                    + templateDetails.section2.groomParents + '     ' + templateDetails.section2.brideParents
            }
            if (weddingData.eventType === 'Botez' || weddingData.eventType === 'Mot' || weddingData.eventType === 'Turta') {
                return templateDetails.section2.groomParents
            }
        }
        if (valueObject.type === 'godparents_text_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section2.text2 + '\n'
                    + templateDetails.section2.text3
            }
        }


        return 'invalid_object_value'
    }

    getTemplateDetails = () => {

        let defaultTemplateValues = getDefaultTemplateValues({
            data: {
                eventType: this.eventType === 'NuntaBotez' ? 'Nunta' : this.eventType
            }
        }, parseInt(this.templateId + ''), 'ro')

        let templateConfigValues = getTemplateConfigValues(parseInt(this.templateId + ''))


        if(this.queryParams.get('introScreen') && this.queryParams.get('introScreen') === 'false') {

        } else {
            if (templateConfigValues.introScreen) {
                defaultTemplateValues.introScreenSection1 = {
                    "brideName": defaultTemplateValues.section1.brideName ? defaultTemplateValues.section1.brideName : 'Mireasă',
                    "groomName": defaultTemplateValues.section1.groomName ? defaultTemplateValues.section1.groomName : 'Mire',
                    "dateStyles": {
                        ...defaultTemplateValues.introScreenSection1.dateStyles,
                        'color': templateConfigValues.colors.fontColor,
                        'activeColor': templateConfigValues.colors.baseColor,
                        'borderColor': templateConfigValues.colors.borderColor
                    },
                    "envelopeColor": {color: templateConfigValues.introScreen.config.envelopeColor},
                    "groomNameStyles": {
                        ...defaultTemplateValues.introScreenSection1.groomNameStyles,
                        'color': templateConfigValues.colors.fontColor
                    },
                    "separatorStyles": {
                        ...defaultTemplateValues.introScreenSection1.separatorStyles,
                        'color': templateConfigValues.colors.fontColor
                    },
                    "brideNameStyles": {
                        ...defaultTemplateValues.introScreenSection1.brideNameStyles,
                        'color': templateConfigValues.colors.fontColor
                    },
                    "envelopeTextStyle": {
                        ...defaultTemplateValues.introScreenSection1.envelopeTextStyle,
                        'color': templateConfigValues.introScreen.config.fontColor
                    },

                    "envelopeText": translateInviteTexts("Apasă pentru a deschide invitația", 'ro')
                }
                defaultTemplateValues.introScreenSection2 = {
                    "confirmButtonIconColor": {'color': templateConfigValues.introScreen.config.fontColor},
                    "viewLocationButtonIconColor": {'color': templateConfigValues.introScreen.config.fontColor},
                    "openInvitationButtonIconColor": {'color': templateConfigValues.introScreen.config.fontColor},
                    "text4": translateInviteTexts("Vă așteptăm cu drag!", 'ro'),
                    "text4Styles": {
                        ...defaultTemplateValues.introScreenSection2.text4Styles,
                        'color': templateConfigValues.colors.fontColor
                    },
                    "showConfirmButton": true,
                    "confirmButtonColor": defaultTemplateValues.introScreenSection1.envelopeColor,
                    "confirmButtonFontStyles": defaultTemplateValues.introScreenSection2.confirmButtonFontStyles,
                    "showViewLocationButton": true,
                    "viewLocationButtonColor": defaultTemplateValues.introScreenSection1.envelopeColor,
                    "viewLocationButtonFontStyles": defaultTemplateValues.introScreenSection2.viewLocationButtonFontStyles,
                    "showOpenInvitationButton": true,
                    "openInvitationButtonColor": defaultTemplateValues.introScreenSection1.envelopeColor,
                    "openInvitationButtonFontStyles": defaultTemplateValues.introScreenSection2.openInvitationButtonFontStyles,
                }
                defaultTemplateValues.introScreenId = templateConfigValues.introScreen.templateId ?? null
                defaultTemplateValues.introScreenConfiguration = templateConfigValues.introScreen.config ?? []
            }
        }


        let eventTypeValue = this.eventType === 'NuntaBotez' ? 'Nunta' : this.eventType
        if (templateConfigValues.introAnimations) {

            if (this.queryParams.get('animation')) {
                if(this.queryParams.get('animation') === 'true') {

                    if(templateConfigValues.introAnimations[1] && this.queryParams.get('animation_type') && this.queryParams.get('animation_type') === 'video') {

                        defaultTemplateValues.introAnimationId = 2

                        //Get predefined sets
                        const predefinedSets = getAnimation2PredefinedSets(eventTypeValue,templateConfigValues.id)

                        const settings = getTemplateSettingsById(templateConfigValues.id)

                        if(predefinedSets && predefinedSets.length > 0) {

                            //Define default configuration values
                            let introAnimationConfiguration = {}
                            let configurationValues = getIntroAnimationConfigValues(defaultTemplateValues.introAnimationId).configuration
                            if(configurationValues) {
                                configurationValues.forEach(item => {
                                    if (templateConfigValues && templateConfigValues.introAnimationsConfig &&
                                        templateConfigValues.introAnimationsConfig[defaultTemplateValues.introAnimationId] && templateConfigValues.introAnimationsConfig[defaultTemplateValues.introAnimationId][item.title])
                                        introAnimationConfiguration[item.title] = templateConfigValues.introAnimationsConfig[defaultTemplateValues.introAnimationId][item.title]
                                    else
                                        introAnimationConfiguration[item.title] = item.value
                                })
                                defaultTemplateValues.introAnimationConfiguration = introAnimationConfiguration
                            }

                            let newPredefinetSet = predefinedSets.find(item => item.id === 1)
                            let newScreens = []
                            for (let i = 0; i < newPredefinetSet.screens.length; i++) {
                                newScreens.push({
                                    id: newPredefinetSet.screens[i].id,
                                    template: newPredefinetSet.screens[i].template
                                })
                                newScreens = this.populateScreenDefaultFieldsAndValues(newScreens, i, defaultTemplateValues, settings)


                                if(newPredefinetSet.secondaryAnimationConfig) {
                                    newScreens[i].data.secondaryAnimationConfig = newPredefinetSet.secondaryAnimationConfig
                                }
                                if(newPredefinetSet.options) {
                                    newScreens[i].data.options = newPredefinetSet.options
                                }

                                //Populate with predefined values
                                let weddingData = {
                                    eventType: eventTypeValue
                                }
                                for (const [key, variable] of Object.entries(newPredefinetSet.screens[i].variables)) {
                                    if (variable.type === 'replace') {
                                        if (variable.main_object && !variable.secondary_object) {
                                            newScreens[i][variable.main_object][variable.parameter] = this.getValueObjectValue(variable.value_object, defaultTemplateValues, weddingData)
                                        }
                                        if (variable.main_object && variable.secondary_object) {
                                            newScreens[i][variable.main_object][variable.secondary_object][variable.parameter] = this.getValueObjectValue(variable.value_object, defaultTemplateValues, weddingData)
                                        }
                                    }
                                    if (variable.type === 'append') {

                                    }

                                }
                            }


                            defaultTemplateValues.introAnimationConfiguration.screens = newScreens


                        }

                    } else {
                        defaultTemplateValues.introAnimationId = templateConfigValues.introAnimations[0]
                        defaultTemplateValues.introAnimationConfiguration = {
                            "birdsColor": "#333333",
                            "autumnLeavesColor": "#9b5300",
                            "optionalAnimation1": "birds"
                        }
                    }
                }
            } else {
                this.setState({showAnimationAskModal: true})
            }
        }
        if (this.eventType === 'Nunta') {

            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Cu inimile pline de emoție și bucurie, noi"
            defaultTemplateValues["section1"]["text2"] = "Vă invităm să fiți alături de noi la celebrarea căsătoriei noastre."
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Mireasă"
            defaultTemplateValues["section1"]["groomName"] = "Mire"

            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section2"]["text1"] = "Alături ne vor fi părinții"
            defaultTemplateValues["section2"]["text2"] = "Și nașii"
            defaultTemplateValues["section2"]["text3"] = "Nașul & Nașa"
            defaultTemplateValues["section2"]["brideParents"] = "Soț & Soție"
            defaultTemplateValues["section2"]["groomParents"] = "Soț & Soție"

            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Nunta"


            return defaultTemplateValues
        }

        if (this.eventType === 'NuntaBotez') {

            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Cu inimile pline de emoție și bucurie, noi"
            defaultTemplateValues["section1"]["text2"] = "Vă invităm să fiți alături de noi la celebrarea căsătoriei căsătoriei noastre și a botezului micuței"
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Mireasă"
            defaultTemplateValues["section1"]["groomName"] = "Mire"
            defaultTemplateValues["section1"]["nuntaSiBotez"] = true
            defaultTemplateValues["section1"]["childrenName"] = "Copil"

            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section2"]["text1"] = "Alături ne vor fi părinții"
            defaultTemplateValues["section2"]["text2"] = "Și nașii"
            defaultTemplateValues["section2"]["text3"] = "Nașul & Nașa"
            defaultTemplateValues["section2"]["brideParents"] = "Soț & Soție"
            defaultTemplateValues["section2"]["groomParents"] = "Soț & Soție"

            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Nunta"

            return defaultTemplateValues
        }

        if (this.eventType === 'Cununie') {
            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Cu inimile pline de emoție și bucurie, noi"
            defaultTemplateValues["section1"]["text2"] = "Vă invităm să fiți alături de noi la celebrarea cununiei noastre."
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Mireasă"
            defaultTemplateValues["section1"]["groomName"] = "Mire"

            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section2"]["text1"] = "Alături ne vor fi părinții"
            defaultTemplateValues["section2"]["text2"] = "Și nașii"
            defaultTemplateValues["section2"]["text3"] = "Nașul & Nașa"
            defaultTemplateValues["section2"]["brideParents"] = "Soț & Soție"
            defaultTemplateValues["section2"]["groomParents"] = "Soț & Soție"

            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Cununie"


            return defaultTemplateValues
        }

        if (this.eventType === 'Botez') {

            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc"
            defaultTemplateValues["section1"]["text2"] = "Împreună cu părinții mei,"
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Copil"
            defaultTemplateValues["section1"]["groomName"] = "Copil"
            defaultTemplateValues["section1"]["text3"] = 'Având alături nașii,'
            defaultTemplateValues["section1"]["text4"] = 'Nașul & Nașa'
            defaultTemplateValues["section1"]["text5"] = 'Avem plăcerea de a vă invita la botezul meu'
            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Botez"

            if (templateConfigValues.introAnimations) {
                if (this.queryParams.get('animation') && this.queryParams.get('animation') === 'true') {
                    defaultTemplateValues.introAnimationId = templateConfigValues.introAnimations[0]
                    defaultTemplateValues.introAnimationConfiguration = {
                        "birdsColor": "#333333",
                        "autumnLeavesColor": "#9b5300",
                        "optionalAnimation1": "confetti"
                    }
                } else {
                    this.setState({showAnimationAskModal: true})
                }
            }

            return defaultTemplateValues
        }

        if (this.eventType === 'Mot') {

            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc"
            defaultTemplateValues["section1"]["text2"] = "Împreună cu părinții mei,"
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Copil"
            defaultTemplateValues["section1"]["groomName"] = "Copil"
            defaultTemplateValues["section1"]["text3"] = 'Având alături nașii,'
            defaultTemplateValues["section1"]["text4"] = 'Nașul & Nașa'
            defaultTemplateValues["section1"]["text5"] = 'Avem plăcerea de a vă invita la tăierea moțului meu'
            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Mot"

            if (templateConfigValues.introAnimations) {
                if (this.queryParams.get('animation') && this.queryParams.get('animation') === 'true') {
                    defaultTemplateValues.introAnimationId = templateConfigValues.introAnimations[0]
                    defaultTemplateValues.introAnimationConfiguration = {
                        "birdsColor": "#333333",
                        "autumnLeavesColor": "#9b5300",
                        "optionalAnimation1": "confetti"
                    }
                } else {
                    this.setState({showAnimationAskModal: true})
                }
            }

            return defaultTemplateValues
        }

        if (this.eventType === 'Turta') {
            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Sunt cel mai frumos dar pe care Dumnezeu l-a făcut părinților mei și mă numesc"
            defaultTemplateValues["section1"]["text2"] = "Împreună cu părinții mei,"
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Copil"
            defaultTemplateValues["section1"]["groomName"] = "Copil"
            defaultTemplateValues["section1"]["text3"] = 'Având alături nașii,'
            defaultTemplateValues["section1"]["text4"] = 'Nașul & Nașa'
            defaultTemplateValues["section1"]["text5"] = 'Avem plăcerea de a vă invita la ruperea turtei mele'
            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Turta"

            if (templateConfigValues.introAnimations) {
                if (this.queryParams.get('animation') && this.queryParams.get('animation') === 'true') {
                    defaultTemplateValues.introAnimationId = templateConfigValues.introAnimations[0]
                    defaultTemplateValues.introAnimationConfiguration = {
                        "birdsColor": "#333333",
                        "autumnLeavesColor": "#9b5300",
                        "optionalAnimation1": "confetti"
                    }
                } else {
                    this.setState({showAnimationAskModal: true})
                }
            }

            return defaultTemplateValues
        }

        if (this.eventType === 'Petrecere') {
            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text2"] = "Vă invităm să ne distrăm împreună și să creăm amintiri frumoase, pline de râsete, jocuri și voie bună."
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Aurora"
            defaultTemplateValues["section1"]["groomName"] = "Aniversarea mea"
            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Petrecere"
            return defaultTemplateValues
        }

        if (corporateWeddingEvents.includes(this.eventType)) {
            defaultTemplateValues["id"] = this.templateId ? parseInt(this.templateId + '') : null
            defaultTemplateValues["section1"]["text1"] = "Te invităm la"
            defaultTemplateValues["section1"]["text2"] = "Aici vei descoperi tendințele actuale, strategii inovatoare și cele mai bune practici, alături de experți de top din industrie."
            defaultTemplateValues["section1"]["image1"] = false
            defaultTemplateValues["section1"]["image2"] = false
            defaultTemplateValues["section1"]["brideName"] = "Aurora"
            defaultTemplateValues["section1"]["groomName"] = "Denumire eveniment business"
            defaultTemplateValues["section2"]["date"] = moment().add('1', 'year').toISOString()
            defaultTemplateValues["section3"]["text4"] = "Vă așteptăm cu drag!"
            defaultTemplateValues['eventType'] = "Petrecere"
            return defaultTemplateValues
        }


    }

    populateScreenDefaultFieldsAndValues = (screens, selectedScreen, defaultTemplateValues, settings) => {

        const defaultImagePlaceholder = '/images/avatar_placeholder.jpg'

        if (screens[selectedScreen].template === 1) {
            screens[selectedScreen].data = {}
            if (!screens[selectedScreen].data)
                screens[selectedScreen].data = {}

            if (!screens[selectedScreen].data.text1)
                screens[selectedScreen].data.text1 = 'Text 1'

            if (!screens[selectedScreen].data.text1Styles)
                screens[selectedScreen].data.text1Styles = defaultTemplateValues.section1.text1Styles

            if (!screens[selectedScreen].data.title)
                screens[selectedScreen].data.title = 'Titlu'

            if (!screens[selectedScreen].data.titleStyles)
                screens[selectedScreen].data.titleStyles = defaultTemplateValues.section1.groomNameStyles

            if (!screens[selectedScreen].data.text2)
                screens[selectedScreen].data.text2 = 'Text 2'

            if (!screens[selectedScreen].data.text2Styles)
                screens[selectedScreen].data.text2Styles = defaultTemplateValues.section1.text1Styles
        }

        if (screens[selectedScreen].template === 2) {
            screens[selectedScreen].data = {}
            if (!screens[selectedScreen].data)
                screens[selectedScreen].data = {}

            if (!screens[selectedScreen].data.date)
                screens[selectedScreen].data.date = defaultTemplateValues.section2.date

            if (!screens[selectedScreen].data.dateStyles)
                screens[selectedScreen].data.dateStyles = defaultTemplateValues.section2.dateStyles

            if (!screens[selectedScreen].data.text1)
                screens[selectedScreen].data.text1 = 'Text 1'

            if (!screens[selectedScreen].data.text1Styles)
                screens[selectedScreen].data.text1Styles = defaultTemplateValues.section1.text1Styles

            if (!screens[selectedScreen].data.text2)
                screens[selectedScreen].data.text2 = 'Text 2'

            if (!screens[selectedScreen].data.text2Styles)
                screens[selectedScreen].data.text2Styles = defaultTemplateValues.section1.text1Styles

        }

        if (screens[selectedScreen].template === 3) {
            screens[selectedScreen].data = {}

            if (!screens[selectedScreen].data.text1)
                screens[selectedScreen].data.text1 = 'Text 1'

            if (!screens[selectedScreen].data.text1Styles)
                screens[selectedScreen].data.text1Styles = defaultTemplateValues.section1.text1Styles

            if (!screens[selectedScreen].data.image1Link)
                screens[selectedScreen].data.image1Link = defaultImagePlaceholder
        }

        if (screens[selectedScreen].template === 4) {
            screens[selectedScreen].data = {}

            if (!screens[selectedScreen].data.text1)
                screens[selectedScreen].data.text1 = 'Text 1'

            if (!screens[selectedScreen].data.text1Styles)
                screens[selectedScreen].data.text1Styles = defaultTemplateValues.section1.text1Styles

            if (!screens[selectedScreen].data.image1Link)
                screens[selectedScreen].data.image1Link = defaultImagePlaceholder

            if (!screens[selectedScreen].data.image2Link)
                screens[selectedScreen].data.image2Link = defaultImagePlaceholder
        }

        if (screens[selectedScreen].template === 5) {
            screens[selectedScreen].data = {}
            if (!screens[selectedScreen].data)
                screens[selectedScreen].data = {}

            if (!screens[selectedScreen].data.title)
                screens[selectedScreen].data.title = 'Titlu'


            //Wave title animation
            if (!screens[selectedScreen].data.titleColor1)
                screens[selectedScreen].data.titleColor1 = settings.introAnimationsConfig[2].wave_title_colors[0]

            if (!screens[selectedScreen].data.titleColor2)
                screens[selectedScreen].data.titleColor2 = settings.introAnimationsConfig[2].wave_title_colors[1]

            if (!screens[selectedScreen].data.titleColor3)
                screens[selectedScreen].data.titleColor3 = settings.introAnimationsConfig[2].wave_title_colors[2]

            //Particles title animation
            if (!screens[selectedScreen].data.titleParticlesColor1)
                screens[selectedScreen].data.titleParticlesColor1 = settings.introAnimationsConfig[2].particles_title_colors[0]
            if (!screens[selectedScreen].data.titleParticlesColor2)
                screens[selectedScreen].data.titleParticlesColor2 = settings.introAnimationsConfig[2].particles_title_colors[1]
            if (!screens[selectedScreen].data.titleParticlesColor3)
                screens[selectedScreen].data.titleParticlesColor3 = settings.introAnimationsConfig[2].particles_title_colors[2]
            if (!screens[selectedScreen].data.titleParticlesColor4)
                screens[selectedScreen].data.titleParticlesColor4 = settings.introAnimationsConfig[2].particles_title_colors[3]
            if (!screens[selectedScreen].data.titleParticlesColor5)
                screens[selectedScreen].data.titleParticlesColor5 = settings.introAnimationsConfig[2].particles_title_colors[4]
            if (!screens[selectedScreen].data.titleParticlesColor6)
                screens[selectedScreen].data.titleParticlesColor6 = settings.introAnimationsConfig[2].particles_title_colors[5]

        }

        return screens
    }

    getValueObjectValue = (valueObject, templateDetails, weddingData) => {

        if (valueObject.type === 'plain') {
            return valueObject.value
        }

        if (valueObject.type === 'variable') {
            if (valueObject.main_object === 'templateDetails') {
                if (valueObject.secondary_object) {
                    return templateDetails[valueObject.secondary_object][valueObject.parameter]
                } else {
                    return templateDetails[valueObject.parameter]
                }
            }
        }
        if (valueObject.type === 'event_title_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section1.groomName + '\n'
                    + (templateDetails.section1.separator && templateDetails.section1.separator === 1 ? translateInviteTexts('și', weddingData.invite.language) : '&') + '\n'
                    + templateDetails.section1.brideName
            }
            if (weddingData.eventType === 'Botez' || weddingData.eventType === 'Mot' || weddingData.eventType === 'Turta') {
                return templateDetails.section1.groomName
            }
            if (weddingData.eventType === 'Petrecere') {
                return templateDetails.section1.groomName
            }
            if (isCorporateWeddingEvent(weddingData)) {
                return templateDetails.section1.groomName
            }
        }

        if (valueObject.type === 'parents_text_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section2.text1 + '\n'
                    + templateDetails.section2.groomParents + '     ' + templateDetails.section2.brideParents
            }
            if (weddingData.eventType === 'Botez' || weddingData.eventType === 'Mot' || weddingData.eventType === 'Turta') {
                return templateDetails.section2.groomParents
            }
        }
        if (valueObject.type === 'godparents_text_full') {
            if (weddingData.eventType === 'Nunta' || weddingData.eventType === 'Cununie') {
                return templateDetails.section2.text2 + '\n'
                    + templateDetails.section2.text3
            }
        }


        return 'invalid_object_value'
    }

    componentDidMount = async () => {

        document.body.classList.add('body-scroll')

        let invite = {
            inviteType: this.queryParams.get('inviteType') ? this.queryParams.get('inviteType') : 'Custom',
            parinti: [
                {
                    "mamaMire": "Alina"
                },
                {
                    "tataMire": "Marian"
                },
                {
                    "mamaMireasa": "Cristina"
                },
                {
                    "tataMireasa": "Adrian"
                },
                {
                    "numeParintiMire": ""
                },
                {
                    "numeParintiMireasa": ""
                }
            ],
            description: 'Vă invităm să petreceți alături de noi',
            nasi: [],
            templateDetails: this.getTemplateDetails(),
            image1: null,
            image2: null,
            fontSize: '20px',
            audioType: 'song',
            song: this.getRandomSong()
        }

        let event_info = {
            data: {
                eventType: this.eventType,
                dataEvent: moment().add('1', 'year').toISOString(),
                prenumeMire: 'Mire',
                prenumeMireasa: 'Mireasă',
                locatii: this.getLocatii(),
                invite: invite
            }
        }
        this.setState({
            inviteType: invite.inviteType,
            inviteContents: invite,
            locations: event_info.data.locatii,
            current_event: event_info.data,
            serverAudioUrl: invite.song.url,
            isUsingAudio: true,
            eventType: event_info.data.eventType,
            showIntroAnimation: event_info.data.invite.templateDetails && event_info.data.invite.templateDetails.introAnimationId,
            showIntroScreen: event_info.data.invite.templateDetails && event_info.data.invite.templateDetails.introScreenId,
            loading: false
        })
    }

    componentWillUnmount() {
        document.body.classList.remove('body-scroll')
        gsap.globalTimeline.clear()
    }

    moveToEvent = () => {
        this.props.history.push('/organizer/eventPage/' + this.props.match.params.id)
    }

    getRandomSong = () => {

        let songs = [{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/background-music-for-holiday-video-vlog-merry-leila-full-version-157683.mp3',
            name: 'Background music for holiday video vlog merry leila',
            id: 1
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/celebration-success-uplifting-joy-225264.mp3',
            name: 'Celebration success uplifting joy',
            id: 2
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/dreamy-lounge-165328.mp3',
            name: 'Dreamy lounge',
            id: 3
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/forever-226243.mp3',
            name: 'Forever',
            id: 4
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/fun-wedding-day-accompanying-background-music-for-holiday-42-sec-157680.mp3',
            name: 'Fun wedding day accompanying background music for holiday',
            id: 5
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/happy-birthday-155461.mp3',
            name: 'Happy birthday',
            id: 6
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/happy-birthday-jazz-171120.mp3',
            name: 'Happy birthday jazz',
            id: 7
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/healing-journey-organic-optimism-223114.mp3',
            name: 'Healing journey organic optimism',
            id: 8
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/inspiring-technologyneon-nodes-223940.mp3',
            name: 'Inspiring technologyneon nodes',
            id: 9
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/invitation-213664.mp3',
            name: 'Invitation',
            id: 10
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/invitation-for-sunset-chillout-youtube-background-music-160883.mp3',
            name: 'Invitation for sunset chillout youtube background music',
            id: 11
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/leva-memories-of-the-pastacousti.mp3',
            name: 'Leva memories of the pastacousti',
            id: 12
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/motivation-every-day-131935.mp3',
            name: 'Motivation every day',
            id: 13
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/positive-mood-163172.mp3',
            name: 'Positive mood',
            id: 14
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/sentimental-guitar-and-piano-164254.mp3',
            name: 'Sentimental guitar and piano',
            id: 15
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Bedtime+Lullaby+For+Baby+Bunnies_1721731281.mp3',
            name: 'Bedtime Lullaby For Baby Bunnies',
            id: 16
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Bright+Horizon+Quest_1721730425.mp3',
            name: 'Bright Horizon Quest',
            id: 17
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Cafe+Jazz+Vibes_1721730708.mp3',
            name: 'Cafe Jazz Vibes',
            id: 18
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-City+Lights+Cool+Jazz_1721730700.mp3',
            name: 'City Lights Cool Jazz',
            id: 19
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Cute+Baby+Smile+Melody_1721731282.mp3',
            name: 'Cute Baby Smile Melody',
            id: 20
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Dance+Of+The+Dark+Joy_1721730593.mp3',
            name: 'Dance Of The Dark Joy',
            id: 21
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Dance-Under-Starlight.mp3',
            name: 'Dance Under Starlight',
            id: 22
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Dark-Delights-Waltz-17.mp3',
            name: 'Dark Delights Waltz',
            id: 23
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Daylight+Dance+Celebration_1721730468.mp3',
            name: 'Daylight Dance Celebration',
            id: 24
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Dreamy+Dusk+Baby+Whispers_1721731287.mp3',
            name: 'Dreamy Dusk Baby Whispers',
            id: 25
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Dreamy+Nighttime+Baby+Beats_1721731280.mp3',
            name: 'Dreamy Nighttime Baby Beats',
            id: 26
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Echoes+Of+Silent+Voices_1721731257.mp3',
            name: 'Echoes Of Silent Voices',
            id: 27
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Echoes+Through+Art_1721731248.mp3',
            name: 'Echoes Through Art',
            id: 28
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Echoes-Through-Time-17.mp3',
            name: 'Echoes Through Time',
            id: 29
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Epic+Calm+Landscapes_1721730401.mp3',
            name: 'Epic Calm Landscapes',
            id: 30
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Eternal+Love+Serenade_1721731277.mp3',
            name: 'Eternal Love Serenade',
            id: 31
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Euphoric+Trap+Party_1721730587.mp3',
            name: 'Euphoric Trap Party',
            id: 32
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Evening+Reflections+Melodies_1721730823.mp3',
            name: 'Evening Reflections Melodies',
            id: 33
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Golden+Afternoon+Serenade_1721731271.mp3',
            name: 'Golden Afternoon Serenade',
            id: 34
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Haunting+Capriccio+Shadows_1721731253.mp3',
            name: 'Haunting Capriccio Shadows',
            id: 35
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Heartbeats+Under+Tribal+Sky_1721731278.mp3',
            name: 'Heartbeats Under Tribal Sky',
            id: 36
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Heavenly+Dreams+Baby+Lullaby_1721731284.mp3',
            name: 'Heavenly Dreams Baby Lullaby',
            id: 37
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Heroic+Love+Overture_1721731261.mp3',
            name: 'Heroic Love Overture',
            id: 38
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Imperial+Palace+Love+Ballad_1721731272.mp3',
            name: 'Imperial Palace Love Ballad',
            id: 39
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Joyful+Anime+Escape_1721730628.mp3',
            name: 'Joyful Anime Escape',
            id: 40
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Joyful+Floral+Morning_1721730611.mp3',
            name: 'Joyful Floral Morning',
            id: 41
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Joyful+Hearts+Unite_1721730590.mp3',
            name: 'Joyful Hearts Unite',
            id: 42
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Joyful+Rhythm+Fiesta_1721730606.mp3',
            name: 'Joyful Rhythm Fiesta',
            id: 43
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Joyful+Summer+Ballroom+Dance_1721730608.mp3',
            name: 'Joyful Summer Ballroom Dance',
            id: 44
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Midnight+Groove+Baby+Babble_1721731288.mp3',
            name: 'Midnight Groove Baby Babble',
            id: 45
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Midnight+Moonlit+Whispers_1721731289.mp3',
            name: 'Midnight Moonlit Whispers',
            id: 46
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Midnight+Violin+Serenade_1721731236.mp3',
            name: 'Midnight Violin Serenade',
            id: 47
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Nighttime+Blissful+Melodies_1721731285.mp3',
            name: 'Nighttime Blissful Melodies',
            id: 48
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Nighttime+Serenade+Tango_1721730601.mp3',
            name: 'Nighttime Serenade Tango',
            id: 49
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Radiant+Jazz+Melody_1721730703.mp3',
            name: 'Radiant Jazz Melody',
            id: 50
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Rhythms+Of+Ancient+Love_1721731268.mp3',
            name: 'Rhythms Of Ancient Love',
            id: 51
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Sunlit+Jazz+Celebration_1721730706.mp3',
            name: 'Sunlit Jazz Celebration',
            id: 52
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Sunrise+Over+Serene+Fields_1721731228.mp3',
            name: 'Sunrise Over Serene Fields',
            id: 53
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Sunshine+Groove+Delight_1721730604.mp3',
            name: 'Sunshine Groove Delight',
            id: 54
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Sweet+Evening+Serenade_1721730707.mp3',
            name: 'Sweet Evening Serenade',
            id: 55
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Timeless+Evening+Waltz_1721731244.mp3',
            name: 'Timeless Evening Waltz',
            id: 56
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Unity+In+Song_1721730595.mp3',
            name: 'Unity In Song',
            id: 57
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Urban+Swagger+Jazz+Night_1721730701.mp3',
            name: 'Urban Swagger Jazz Night',
            id: 58
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Victory+Festival+Grand+Symphony_1721730410.mp3',
            name: 'Victory Festival Grand Symphony',
            id: 59
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Whispers+Of+Innocent+Love_1721731274.mp3',
            name: 'Whispers Of Innocent Love',
            id: 60
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Whispers+Of+The+Evening_1721730704.mp3',
            name: 'Whispers Of The Evening',
            id: 61
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Whispers+Of+The+Heart_1721731275.mp3',
            name: 'Whispers Of The Heart',
            id: 62
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/StockTune-Yearning+Violin+Serenade_1721731232.mp3',
            name: 'Yearning Violin Serenade',
            id: 63
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/sunny-happiness-225159.mp3',
            name: 'Sunny happiness',
            id: 64
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/technology-future-frequencies-221199.mp3',
            name: 'Technology future frequencies',
            id: 65
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/uplifting-celebration-success-time-226311.mp3',
            name: 'Uplifting celebration success time',
            id: 66
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/valentine-191922.mp3',
            name: 'Valentine',
            id: 67
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/warm-rays-of-hope-131936.mp3',
            name: 'Warm rays of hope',
            id: 68
        },{
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/wide-space-156798.mp3',
            name: 'Wide space',
            id: 69
        }]

        let song = {
            url: 'https://ality-audio.s3.eu-north-1.amazonaws.com/background-music-for-holiday-video-vlog-merry-leila-full-version-157683.mp3',
            name: 'Background music for holiday video vlog merry leila',
            id: 1
        }

        try {
            song = songs[Math.floor(Math.random() * songs.length)];
        } catch (e) {

        }

       return song
    }

    setAnswer = (ans) => {
        this.setState({
            answer: ans
        })

        this.timer = setTimeout(
            () => this.state.topRef.current.scrollIntoView(),
            100
        )
    }

    setter = (key, value) => {
        this.setState({
            [key]: value
        })
    }

    changeAnswers = (newAnswers) => {
        this.setState({
            answers: newAnswers
        })
    }

    sendAnswer = () => {
        toast.info('Trimiterea răspunsurilor este dezactivată în modul de previzualizare!')
    }

    showBottomButtons = () => {

        if(this.queryParams.get('websiteConfigurator')) {
            return null
        }


        return <>

            <Modal
                classNames={{
                    overlay: 'modal-overlay',
                    modal: 'modal-no-top',
                    closeButton: 'modal-close-button',
                }}
                open={this.state.showAnimationAskModal}
                focusTrapped={false}
                onClose={() => {
                    this.setState({
                        showAnimationAskModal: false
                    })
                }}
            >

                <div className={"WebsiteInviteModuleDemo-intro-modal"}>
                    <h4>Invitație animată</h4>
                    <br/>
                    <p>
                        Am creat o variantă animată și configurabilă a acestei invitații, pe care o
                        oferim gratuit pentru o perioadă limitată. Doriți să încercați invitația
                        animată?
                    </p>

                    <div className={"cards-title"}>Alege:</div>
                    <div className={"cards"}>
                        <div
                            className={"cards-item"}
                             onClick={() => {
                                 this.setState({showAnimationAskModal: false})
                                 window.location.replace(window.location.href + '&animation=true')
                             }}>

                            <div className={"image"}>
                                <img src={getTemplateConfigValues(parseInt(this.templateId + '')).preview} alt={""} />

                                <div className={"icon first"}>
                                    <Icon icon="play" />
                                </div>
                            </div>

                            <div className={"title"}>
                                Invitație animată
                            </div>
                        </div>
                        <div
                            className={"cards-item"}
                            onClick={() => {
                                this.setState({showAnimationAskModal: false})
                                window.location.replace(window.location.href + '&animation=true&animation_type=video')
                            }}>

                            <div className={"image"}>
                                <img src={getTemplateConfigValues(parseInt(this.templateId + '')).preview} alt={""} />

                                <div className={"icon first"}>
                                    <Icon icon="video-camera" />
                                </div>
                            </div>

                            <div className={"title"}>
                                Invitație video
                            </div>
                        </div>
                        <div
                            className={"cards-item"}
                             onClick={() => this.setState({showAnimationAskModal: false})}>

                            <div className={"image"}>
                            <img src={getTemplateConfigValues(parseInt(this.templateId + '')).preview} alt={""} />
                            </div>

                            <div className={"title"}>
                                Invitație standard
                            </div>
                        </div>
                    </div>

                </div>


            </Modal>

            <div><br/>
                <Button className="action btn-back"
                        style={{marginRight: "10px", padding: "10px 15px"}}
                        onClick={() => this.props.history.push('/organizer/websiteInviteModule?templateId=' + this.templateId + '&eventType=' + this.eventType + '&selectTemplate=true')}
                        color="blue"> Vezi toate modelele </Button>

                <Button className="action btn-back" style={{padding: "10px 15px"}}
                        onClick={() => this.props.history.push('/organizer/websiteInviteModule?templateId=' + this.templateId + '&eventType=' + this.eventType)}
                        color="green"> Personalizează invitația</Button>
            </div>
        </>

    }
    scrollContainerBottom = () => {
        if (this.state.formRef && this.state.formRef.current) {
            setTimeout(
                () => this.state.formRef.current.scrollIntoView(),
                10
            )
        }
    }
    scrollToLocations = () => {
        setTimeout(
            () => {
                let element = document.getElementsByClassName("locations-inner")[0];
                if(element) {
                    element.scrollIntoView()
                }
            },
            10
        )
    }
    render() {
        if (this.state.loading) {
            return <LoadingScreen/>
        }

        if (this.state.inviteContents && this.state.inviteContents.templateDetails && this.state.inviteContents.templateDetails.id) {
            return (<>
                        {this.state.showIntroScreen && !this.queryParams.get('websiteConfigurator') ? <Button className="action btn-back" style={{
                            padding: "10px 15px",
                            position: "absolute", left: '20px', top: '20px',
                            backgroundColor: "darkgrey", zIndex: 202
                        }}
                                 onClick={() => this.props.history.push('/organizer/websiteInviteModule?templateId=' +
                                     this.templateId + '&eventType=' + this.eventType)}
                                 color="red">Personalizează invitația</Button> : null}

                      {this.state.inviteContents.templateDetails.introScreenId && this.state.inviteContents.templateDetails.introScreenId > 0 ?
                                <IntroScreenTemplateRenderLazy
                                    showIntroScreen={this.state.showIntroScreen}
                                    templateDetails={this.state.inviteContents.templateDetails}
                                    weddingData={this.state.current_event}
                                    showIntroAnimation={() => {
                                        if (this.state.showIntroAnimation !== true && this.state.current_event.invite.templateDetails && this.state.current_event.invite.templateDetails.introAnimationId)
                                            this.setState({
                                                showIntroAnimation: true
                                            })
                                    }}
                                    openInvitation={() => {
                                        this.setState({
                                            autoPlayIntroAnimation: true,
                                            showIntroScreen: false,
                                        })
                                    }}
                                    mode={0}
                                    goToAnswer={() => {
                                        this.setState({
                                            showIntroScreen: false,
                                            showIntroAnimation: false,
                                        }, () => {
                                            this.setState({
                                                animationState: 'ended'
                                            })
                                            if(!this.queryParams.get('websiteConfigurator')) {
                                                this.scrollContainerBottom()
                                            }
                                        })
                                    }}
                                    goToLocations={() => {
                                        this.setState({
                                            showIntroScreen: false,
                                            showIntroAnimation: false,
                                        }, () => {
                                            this.setState({
                                                animationState: 'ended'
                                            })

                                            if(!this.queryParams.get('websiteConfigurator')) {
                                                this.scrollToLocations()
                                            }
                                        })
                                    }}
                                    goToInvitation={() => {
                                        this.setState({
                                                showIntroScreen: false,
                                                showIntroAnimation: false,
                                            }, () =>
                                                this.setState({
                                                    animationState: 'ended'
                                                })
                                        )

                                    }}
                                    showResponseButton={!this.props.disableAction && !this.state.inviteContents.hideConfirmForm}
                                />:null}

                    <IntroAnimationRenderComp
                        show={this.state.inviteContents.templateDetails && this.state.inviteContents.templateDetails.introAnimationId && !this.state.showIntroScreen}
                        showIntroAnimation={this.state.showIntroAnimation}
                        showInvite={!(this.state.showIntroAnimation || this.state.showIntroScreen)}
                        templateDetails={this.state.inviteContents.templateDetails}
                        weddingData={this.state.current_event}
                        setShowInvite={(value) => this.setState({showIntroAnimation: !value})}
                        setAutoPlayIntroAnimation={(value) => this.setState({autoPlayIntroAnimation: value})}
                        autoPlayIntroAnimation={this.state.autoPlayIntroAnimation}
                        animationState={this.state.animationState}
                        setAnimationState={(value) => {
                            this.setState({
                                animationState:value
                            })
                        }}
                    />
                    {!this.state.showIntroScreen && !this.state.showIntroAnimation &&
                    this.state.current_event && this.state.current_event.invite &&
                    this.state.current_event.invite.templateDetails && this.state.current_event.invite.templateDetails.introScreenId ?
                        <Button className="action btn-back inv-top-btn"
                                style={{
                                    position: "fixed",
                                    top: '20px',
                                    left: '20px',
                                    zIndex: 1000,
                                    backgroundColor: "darkgrey"
                                }}
                                onClick={() => this.setState({
                                    animationState: 'ended',
                                    showIntroAnimation: false,
                                    showIntroScreen: true
                                })}
                                color="red"> <Icon icon="home" style={{color: "white"}}/>
                        </Button> : null}
                    <div className={"new-invite-container " + (this.state.showIntroAnimation || this.state.showIntroScreen ? "inviteHiddenCont" : "")}
                         style={this.state.showIntroAnimation || this.state.showIntroScreen ? {
                             //position: 'absolute',
                             //left: '-200vw'
                         } : {zIndex: 1001, ...(this.queryParams.get('websiteConfigurator') ? {minHeight:'unset'} : {})}}>

                        <div className={"new-invite-container-inner"}>
                            <div className={"invite-container"}>
                                <InviteTemplateRenderLazy
                                    templateDetails={this.state.inviteContents.templateDetails}
                                    weddingData={this.state.current_event}
                                    locations={this.state.current_event.locatii}
                                    audioLink={this.state.isUsingAudio && this.state.serverAudioUrl ? this.state.serverAudioUrl : ''}
                                    image1Link={this.state.current_event.invite.image1 ? `https://${process.env.REACT_APP_IMAGE_DOMAIN}${this.state.current_event.invite.image1.url}` : ''}
                                    image2Link={this.state.current_event.invite.image2 ? `https://${process.env.REACT_APP_IMAGE_DOMAIN}${this.state.current_event.invite.image2.url}` : ''}
                                    mode={1}
                                />


                                {!this.props.disableAction &&
                                    <div className="Answer" ref={this.state.formRef} style={this.state.showIntroAnimation || this.state.showIntroScreen ? {opacity:0, position:'relative'} : {position:'relative'}}>

                                        {this.queryParams.get('websiteConfigurator') ? <div style={{position:'absolute', width:'100%', height:'100%', background:'rgba(255,255,255,0.4)'}}></div>:null}

                                        <p style={{fontSize: "20px"}}>Doriți să participați?</p>

                                        <div className="Options">
                                            <div className="Yes"
                                                 onClick={() => this.setAnswer("yes")}>Particip
                                            </div>

                                            <div className="No"
                                                 onClick={() => this.setAnswer("no")}>Nu
                                                Particip
                                            </div>

                                            {
                                                this.state.inviteContents.hideDontKnowButton ?
                                                    null
                                                    :
                                                    <div className="NotSure"
                                                         onClick={() => this.setAnswer("don't know")}>Nu
                                                        știu</div>
                                            }
                                        </div>
                                    </div>
                                }

                                {this.state.answer !== "" && <div className='Form'>
                                    <div ref={this.state.topRef}></div>

                                    <div style={{textAlign: "left", fontSize: "18px"}}>Vă rugăm
                                        introduceți următoarele informații:
                                    </div>

                                    <CustomInput value={this.state.prenume}
                                                 onChange={value => this.setter("prenume", value)}
                                                 placeholder={"Prenume, Nume"}/>

                                    <CustomInput value={this.state.email}
                                                 onChange={value => this.setter("email", value)}
                                                 style={{marginTop: 0}}
                                                 placeholder={"Adresa de email"}/>

                                    {/* <CustomInput value={this.state.nume} onChange={value => this.setter("nume", value)} placeholder={"Nume"} /> */}
                                    {this.state.answer === "no" &&
                                        <p>Ne pare rău să auzim asta, daca vă răzgândiți vă
                                            așteptam</p>}
                                    {this.state.answer === "don't know" &&
                                        <p>Nu este obligatoriu să răspundeți acum, când sunteți
                                            sigur</p>}

                                    {this.state.answer === "yes" ?
                                        isCorporateWeddingEvent(this.state.current_event) ?
                                            <div>
                                                <div className="data-row">
                                                    <div
                                                        className={(!this.state.current_event.invite.hideChildrenQuestion ? !this.state.cuCopii : !this.state.insotit) ? "active-option" : "inactive-option"}
                                                        onClick={_ => {
                                                            if (!this.state.current_event.invite.hideChildrenQuestion) {
                                                                this.setter("cuCopii", false)
                                                            } else {
                                                                this.setter("insotit", false)
                                                            }
                                                        }}>
                                                        {translateInviteTexts('Vin singur/ă', this.state.current_event.invite.language)}
                                                    </div>

                                                    <div
                                                        className={(!this.state.current_event.invite.hideChildrenQuestion ? this.state.cuCopii : this.state.insotit) ? "active-option" : "inactive-option"}
                                                        onClick={_ => {
                                                            if (!this.state.current_event.invite.hideChildrenQuestion) {
                                                                this.setter("cuCopii", true)
                                                            } else {
                                                                this.setter("insotit", true)
                                                            }
                                                        }}>
                                                        {translateInviteTexts('Vin insoțit/ă', this.state.current_event.invite.language)}
                                                    </div>
                                                </div>

                                                {
                                                    this.state.insotit && this.state.current_event.invite.hideChildrenQuestion ?
                                                        <CustomInput value={this.state.nume_insotitor}
                                                                     onChange={value => this.setter("nume_insotitor", value)}
                                                                     placeholder={translateInviteTexts("Prenume, Nume Insotitor", this.state.current_event.invite.language)}/>
                                                        : null
                                                }

                                                {this.state.cuCopii && !this.state.current_event.invite.hideChildrenQuestion ?
                                                    <>
                                                        <div style={{
                                                            fontSize: "18px",
                                                            textAlign: "left"
                                                        }}>{translateInviteTexts('Alegeți numărul de insoțitori', this.state.current_event.invite.language)}</div>
                                                        <div className="data-row">
                                                            {this.state.kidsNumberOptions.map((nr, index) =>
                                                                <div key={index}
                                                                     className={parseInt(this.state.nr_copii + '') === parseInt(nr + '') ? "active-option" : "inactive-option"}
                                                                     onClick={_ => {
                                                                         this.setter("cuCopii", true)
                                                                         this.setter("nr_copii", nr)
                                                                     }}>
                                                                    {nr}
                                                                </div>)}
                                                        </div>
                                                    </>
                                                    : null
                                                }

                                                {this.state.shouldUseCustomQuestions && this.state.customQuestions.length >0 &&
                                                    <CustomQuestions questions={this.state.customQuestions}
                                                                     answers={this.state.answers}
                                                                     showTitle={true}
                                                                     changeAnswers={this.changeAnswers}
                                                                     language={this.state.current_event.invite.language}
                                                                     intl={this.props.intl}/>}
                                            </div>
                                            :
                                            <div>
                                                <div className="data-row">
                                                    <div
                                                        className={!this.state.insotit ? "active-option" : "inactive-option"}
                                                        onClick={_ => this.setter("insotit", false)}>
                                                        {translateInviteTexts('Vin singur/ă', this.state.current_event.invite.language)}
                                                    </div>

                                                    <div
                                                        className={this.state.insotit ? "active-option" : "inactive-option"}
                                                        onClick={_ => this.setter("insotit", true)}>
                                                        {translateInviteTexts('Vin insoțit/ă', this.state.current_event.invite.language)}
                                                    </div>
                                                </div>
                                                {this.state.insotit && (
                                                    <CustomInput value={this.state.nume_insotitor}
                                                                 onChange={value => this.setter("nume_insotitor", value)}
                                                                 placeholder={translateInviteTexts("Prenume, Nume Insotitor", this.state.current_event.invite.language)}/>
                                                )}

                                                {
                                                    this.state.current_event.invite.hideChildrenQuestion ?
                                                        null
                                                        :
                                                        this.state.current_event.eventType !== 'Petrecere' ?
                                                            <>
                                                                {
                                                                    this.state.current_event.id_eveniment === '1Duxg' ?
                                                                        null
                                                                        : <>
                                                                            <div style={{
                                                                                fontSize: "18px",
                                                                                textAlign: "left"
                                                                            }}>{translateInviteTexts('Veniți însoțiți de copii?', this.state.current_event.invite.language)}</div>
                                                                            <div className="data-row">
                                                                                <div
                                                                                    className={!this.state.cuCopii ? "active-option" : "inactive-option"}
                                                                                    onClick={_ => this.setter("cuCopii", false)}>
                                                                                    {translateInviteTexts('Nu', this.state.current_event.invite.language)}
                                                                                </div>

                                                                                <div
                                                                                    className={this.state.cuCopii ? "active-option" : "inactive-option"}
                                                                                    onClick={_ => this.setter("cuCopii", true)}>
                                                                                    {translateInviteTexts('Da', this.state.current_event.invite.language)}
                                                                                </div>
                                                                            </div>
                                                                        </>}
                                                            </>
                                                            : null
                                                }
                                                {this.state.cuCopii && (
                                                    <div>
                                                        <div style={{
                                                            fontSize: "18px",
                                                            textAlign: "left"
                                                        }}>{translateInviteTexts('Cu câți copii veniți?', this.state.current_event.invite.language)}</div>

                                                        <div className="data-row">
                                                            {this.state.kidsNumberOptions.map((nr, index) =>
                                                                <div key={index}
                                                                     className={this.state.nr_copii === nr ? "active-option" : "inactive-option"}
                                                                     onClick={_ => this.setter("nr_copii", nr)}>
                                                                    {nr}
                                                                </div>)}
                                                        </div>
                                                    </div>
                                                )}

                                                {this.state.shouldUseCustomQuestions &&
                                                    <CustomQuestions questions={this.state.customQuestions}
                                                                     answers={this.state.answers}
                                                                     showTitle={true}
                                                                     changeAnswers={this.changeAnswers}
                                                                     language={this.state.current_event.invite.language}
                                                                     intl={this.props.intl}/>}
                                            </div>
                                        :null
                                    }

                                    <br/>
                                    <Button onClick={this.sendAnswer} className="add-button"
                                            style={{
                                                backgroundColor: "#00afcc",
                                                color: "white",
                                                height: '60px'
                                            }}>
                                        Trimite răspuns
                                    </Button>

                                    <div style={{
                                        marginTop: "50px",
                                        marginBottom: "50px",
                                        fontSize: "18px"
                                    }}>
                                        Vă mulțumim!
                                    </div>

                                </div>}

                            </div>

                            {this.showBottomButtons()}
                        </div>
                    </div>
                </>
            )
        }


        let style = {
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundPosition: 'top',
            backgroundImage: this.state.inviteContents.image !== null ? `url(https://${process.env.REACT_APP_IMAGE_DOMAIN}${getUrlFromImage(this.state.inviteContents.image)})` : ""
        }

        let customStyle = {
            color: this.state.inviteContents.fontColor,
            fontFamily: this.state.inviteContents.fontFamily,
            fontSize: this.state.inviteContents.fontSize,
        }

        let locations = this.state.locations.map((location, index) => {
            let time = new Date(location.time)
            let day = new Date(location.time)

            if (location.day !== undefined) {
                day = new Date(location.day)
            }

            let icon = <ImLocation/>

            if (location.name === "Locatie petrecere") {
                icon = <IoMdRestaurant/>
            } else if (location.name === "Locatie biserica") {
                icon = <GiChurch/>
            } else if (location.name === "Locatie cununie") {
                icon = <GiFamilyHouse/>
            }

            return <div key={index} style={{margin: "10px 0px"}}>
                <div style={{
                    color: this.state.inviteContents.fontColor,
                    fontFamily: this.state.inviteContents.fontFamily,
                    fontSize: Number(this.state.inviteContents.fontSize.split("px")[0]) + 5 + "px"
                }}>{location.name}</div>

                {icon}

                <div style={customStyle}>{location.label ? location.label : location.address}</div>

                <div
                    style={customStyle}>{moment(day).format('DD-MM-YYYY')} {moment(time).format('HH:mm')}</div>

                {
                    location.pinx && location.piny ?
                        <div className={"buttons"}>
                            <div className={"waze"}
                                 onClick={() => openWaze(location.pinx, location.piny, 0)}><SiWaze
                                style={{marginRight: "5px"}}/> Waze
                            </div>
                            <div className={"maps"}
                                 onClick={() => openMaps(location.pinx, location.piny, 0)}>
                                <SiGooglemaps style={{marginRight: "5px"}}/> Google Maps
                            </div>
                        </div>
                        : null
                } </div>
        })

        let body = <div></div>

        if (this.state.inviteType === "Personal") {
            body = <div style={{marginTop: "20px"}}>
                <img
                    src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}${getUrlFromImage(this.state.inviteContents.image)}`}
                    alt={"Invitatie personala"} style={{width: "80vw"}}/>
                {this.state.isUsingAudio && <PlayAudio
                    link={this.state.serverAudioUrl}/>}
                {this.showBottomButtons()}
            </div>
        }

        if (this.state.inviteType === "Video") {
            // console.log(this.state.inviteContents.linkVideo);
            let linkParts = this.state.inviteContents.linkVideo.split("watch?v=")
            let link = ""
            if (linkParts.length === 1) {
                link = linkParts[0]
            } else {
                link = linkParts[0] + "embed/" + linkParts[1]
            }

            let videoId = ''
            try {
                videoId = this.state.inviteContents.linkVideo.split("watch?v=")[1].split("&")[0]
            } catch (e) {

            }
// console.log(link);
            body = <div className="MainInvite-contents" style={customStyle}>
                {/* <iframe src={link.split("&")[0]}
					frameBorder='0'
					allow='autoplay; encrypted-media'
					allowFullScreen={true}
					title='video'
					style={{ width: "80vw", height: "500px", margin: "20px auto" }}
				/> */}
                <PlayVideo videoId={videoId} link={link.split("&")[0]}
                           style={{width: "80vw", height: "500px", margin: "20px auto"}}/>

                {this.showBottomButtons()}
            </div>
        }

        if (this.state.inviteType === "Custom") {
            let has_both_parents_mire = this.state.inviteContents.parinti[1].tataMire !== "" && this.state.inviteContents.parinti[0].mamaMire !== ""
            let has_at_least_one_parent_mire = this.state.inviteContents.parinti[1].tataMire !== "" || this.state.inviteContents.parinti[0].mamaMire !== ""

            let has_both_parents_mireasa = this.state.inviteContents.parinti[3].tataMireasa !== "" && this.state.inviteContents.parinti[4].mamaMireasa !== ""
            let has_at_least_one_parent_mireasa = this.state.inviteContents.parinti[3].tataMireasa !== "" || this.state.inviteContents.parinti[4].mamaMireasa !== ""

            if (this.state.eventType === "Nunta") {
                body = <div className="MainInvite-contents" style={customStyle}>
                    <h3 style={{
                        marginBottom: "40px",
                        marginTop: "40px"
                    }}>{this.state.current_event.prenumeMire} și {this.state.current_event.prenumeMireasa}</h3>

                    <p>Spre bucuria părinților,</p>
                    <div className="parents">
                        {has_at_least_one_parent_mire && <div>
                            <div>{this.state.inviteContents.parinti[1].tataMire} {has_both_parents_mire ? "și" : ""} {this.state.inviteContents.parinti[0].mamaMire}</div>

                            <div>{this.state.inviteContents.parinti[4].numeParintiMire}</div>
                        </div>}

                        {has_at_least_one_parent_mireasa && <div>
                            <div>{this.state.inviteContents.parinti[3].tataMireasa} {has_both_parents_mireasa ? "și" : ""} {this.state.inviteContents.parinti[2].mamaMireasa}</div>

                            <div>{this.state.inviteContents.parinti[5].numeParintiMireasa}</div>
                        </div>}
                    </div>

                    {this.state.inviteContents.nasi.length > 0 &&
                        <p style={{marginBottom: "20px"}}>și a nașilor,</p>}
                    {this.state.inviteContents.nasi.length > 0 &&
                        <div>{this.state.inviteContents.nasi[0].numeNas} și {this.state.inviteContents.nasi[0].numeNasa} {this.state.inviteContents.nasi[0].numeFamilie}</div>}

                    <p style={{margin: "20px 10px"}}>{this.state.inviteContents.description}</p>


                    {this.state.isUsingAudio && <PlayAudio
                        link={this.state.serverAudioUrl}/>}
                    <div className="locations">
                        {locations}
                    </div>

                    {this.showBottomButtons()}
                </div>
            }

            if (this.state.eventType === "Botez") {
                body = <div className="MainInvite-contents" style={customStyle}>
                    <h3 style={{margin: "10px auto"}}>Salut, ma
                        numesc {this.state.current_event.prenumeMire}</h3>

                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: 'space-around',
                        margin: "10px 0px 0px 0px"
                    }}>
                        <div>Alături de parinții mei,</div>
                        <div>{this.state.inviteContents.parinti[1].tataMire} și {this.state.inviteContents.parinti[0].mamaMire}</div>
                    </div>

                    {this.state.inviteContents.nasi.length > 0 &&
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: 'space-around'
                        }}>
                            <div>și nașii,</div>
                            {this.state.inviteContents.nasi[0].numeNas} și {this.state.inviteContents.nasi[0].numeNasa} {this.state.inviteContents.nasi[0].numeFamilie}
                        </div>}

                    <p style={{margin: "20px 10px"}}>{this.state.inviteContents.description}</p>
                    {this.state.isUsingAudio && <PlayAudio
                        link={this.state.serverAudioUrl}/>}
                    <div className="locations">
                        {locations}
                    </div>

                    {this.showBottomButtons()}
                </div>
            }

            if (this.state.eventType === "Petrecere") {
                body = <div className="MainInvite-contents" style={customStyle}>
                    <h3 style={{marginBottom: "10px"}}>Salut, sunteti invitati la
                        petrecerea {this.state.current_event.prenumeMire}</h3>

                    <p style={{margin: "20px 10px"}}>{this.state.inviteContents.description}</p>

                    {this.state.isUsingAudio && <PlayAudio
                        link={this.state.serverAudioUrl}/>}
                    <div className="locations">
                        {locations}
                    </div>

                    {this.showBottomButtons()}
                </div>
            }
        }

        return (
            <div className="MainInvite-container"
                 style={this.state.inviteType === "Custom" ? style : {}}>
                {body}
            </div>
        )
    }
}

export default WebsiteInviteModuleDemo;
